// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"350":"3d46c81a","360":"f2ae547d","445":"9d11256a","453":"e67b519e","455":"766972e6","513":"bfb6d119","536":"c52585b7","827":"cbf165f3","944":"0a0f5139","949":"de655453","977":"2626d0aa","994":"2759427e"}[chunkId] + ".chunk.js";
};